import _ from 'lodash';
import { StoreTags } from 'utils/types';

const STORE_TAG_SEPARATOR = '-';
const NIELSEN_TAG_SUFFIX = '666666';

class PageHeaderUtils {
  static createStoreId = (spinsTag, nielsenTag) => {
    const spins = spinsTag !== null ? spinsTag : '';
    const nielsen = nielsenTag !== '' && nielsenTag !== null ? `${nielsenTag}` : '';
    return spins && nielsen ? `${spins}${STORE_TAG_SEPARATOR}${nielsen}` : `${spins}${nielsen}`;
  };

  static getTagsFromStoreId = (storeId: string = null): StoreTags => {
    if (storeId !== '' && storeId !== null) {
      if (storeId.includes(STORE_TAG_SEPARATOR)) {
        const tokens = storeId.split(STORE_TAG_SEPARATOR);
        return {
          spins: tokens[0] ? (tokens[0] !== '' ? tokens[0] : null) : null,
          nielsen: tokens[1]
            ? tokens[1] !== ''
              ? tokens[1].replace(NIELSEN_TAG_SUFFIX, '')
              : null
            : null
        };
      } else {
        if (storeId.includes(NIELSEN_TAG_SUFFIX))
          return { spins: null, nielsen: storeId.replace(NIELSEN_TAG_SUFFIX, '') };
        else return { spins: storeId, nielsen: null };
      }
    }
    return null;
  };

  static mapStoresIds = (storesIds: Array<string>) => {
    const stores = storesIds.map((storeId: string) => {
      const tokens: Array<string> = storeId.split('-');
      return tokens.filter(token => token !== '');
    });
    return _.flatten(stores);
  };
}

export default PageHeaderUtils;
